export const EMPTY_STATUS_VALUE = "__EMPTY_STATUS__";

export const getAssigneeNameFromId = (
  assigneeId: string | null,
  assigneeIdToName?: Record<string, string>,
): string | null => {
  if (!assigneeId || !assigneeIdToName) return assigneeId;
  return assigneeIdToName[assigneeId] ?? assigneeId;
};

export const normalizeStatusValue = (value: string | null): string => {
  if (!value) return EMPTY_STATUS_VALUE;
  return value;
};

export const denormalizeStatusValue = (
  displayValue: string | null,
): string | null => {
  if (displayValue === EMPTY_STATUS_VALUE) return null;
  return displayValue;
};

export const getDisplayValue = (rawValue: any, valueToUpdate: string): any => {
  if (valueToUpdate === "discrepancy_status")
    return normalizeStatusValue(rawValue);
  if (valueToUpdate === "discrepancy_assignee")
    return !rawValue || rawValue.trim() === "" ? "Unassigned" : rawValue;
  return rawValue;
};

export const prepareMutationValue = (
  selected: string | null,
  valueToUpdate: string,
): string | null => {
  if (valueToUpdate === "discrepancy_status")
    return denormalizeStatusValue(selected);
  if (valueToUpdate === "discrepancy_assignee") {
    if (!selected || selected === "Unassigned") return null;
    return selected;
  }
  return selected;
};
